import { passwordCharacters } from './kidsLeavePopup.constant';

export const generatePassword = length => {
  let result = '';
  for (let i = 0; i < length; i += 1) {
    result += passwordCharacters[Math.floor(Math.random() * passwordCharacters.length)];
  }

  return result;
};
